import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, H3, H5, Image, LI, P, UL } from "../../../../AbstractElements";
import { FREE, FileFilter, Selected, TrialVersion } from "../../../../utils/Constant";
import { sideButtons } from "../../../../Data/Application/FileSideBar/FileSideBar";
import StoragePlan from "./StoragePlan";
import PricingPlans from "./PricingPlans";
import { dynamicImage } from "../../../../Service";

const FileSideBar = () => {
  const [IsOpen, setIsOpen] = useState(false);
  return (
    <Col xl="3" className="box-col-30">
      <div className="md-sidebar job-sidebar">
        <Btn color="primary" className="md-sidebar-toggle" onClick={() => setIsOpen(!IsOpen)} >
          {FileFilter}
        </Btn>
        <div className={`md-sidebar-aside custom-scrollbar ${IsOpen ? "open" : "" }`} >
          <div className="file-sidebar">
            <Card>
              <CardBody>
                <UL className="simple-list">
                  {sideButtons.map((item, i) => (
                    <LI key={i}>
                      <Btn color={item.className} block className="text-start">
                        {item.icon}
                        {item.title}
                      </Btn>
                    </LI>
                  ))}
                </UL>
                <hr style={{ opacity: 0.25 }} />
                <StoragePlan />
                <hr style={{ opacity: 0.25 }} />
                <PricingPlans />
              </CardBody>
              <div className="pricing-plan">
                <H5 className="f-w-700">{TrialVersion} </H5>
                <H3>{FREE}</H3>
                <P>{"100 GB Space"}</P>
                <Btn size="xs" color="primary" outline>
                  {Selected}
                </Btn>
                <Image className="bg-img" src={dynamicImage("dashboard/folder.png")} alt="dashboard" />
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default FileSideBar;
